import { render, staticRenderFns } from "./audioread.vue?vue&type=template&id=20a85b09&scoped=true&"
import script from "./audioread.vue?vue&type=script&lang=js&"
export * from "./audioread.vue?vue&type=script&lang=js&"
import style0 from "./audioread.vue?vue&type=style&index=0&id=20a85b09&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a85b09",
  null
  
)

export default component.exports